import { Icon, theme, Tooltip } from "@yuno/design-system-web"
import { InputKeyButton, InputRemoveButton, SpanCredentialsStyled } from "./styles"
import { useTranslation } from 'react-i18next'

interface IconKeyTestOptionsProps {
  isMainInput: boolean
  hasTestValue: boolean
  isCreateMode: boolean
  handleTestKeyButton: (boolean) => void
  resetTestKeyProps: (boolean) => void
  toggleState: boolean
}

export const IconKeyTestOptionsV2 = ({
  isMainInput,
  hasTestValue,
  isCreateMode,
  handleTestKeyButton,
  resetTestKeyProps,
  toggleState
}: IconKeyTestOptionsProps) => {
  const { t } = useTranslation()
    if (isMainInput && isCreateMode) {
      if (hasTestValue && !toggleState) { 
        return (
          <Tooltip
          title={t('useCredentials')}
            color="default"
          >
            <InputKeyButton type='button' onClick={handleTestKeyButton.bind(null, hasTestValue)} >
              <Icon
                name="Key"
                weight="fill"
                width='16px'
                height='16px'
              />
            </InputKeyButton>
          </Tooltip>
        )
      } 
      return (
        <InputRemoveButton type='button' onClick={resetTestKeyProps.bind(null, hasTestValue)} >
          <Icon
            name="XCircle"
            weight="fill"
            color={theme.palette.grey[5]}
            width='16px'
            height='16px'
          />
        </InputRemoveButton>
      )
		} else if (!isCreateMode && hasTestValue) {
			return (<SpanCredentialsStyled> { t('yunoCredentials') } </SpanCredentialsStyled>)
		}
  }
